import { Card } from './card/card';

export class GameLogicDepth {
  private cardDepthOrder: number;
  private cardDepths: Map<number, number>;

  constructor() {
    this.cardDepthOrder = 0;
    this.cardDepths = new Map();
  }

  public updateCardDepth(index: number) {
    this.cardDepths.set(index, this.nextCardDepthOrder());
  }

  public cardDepth(card: Card): number {
    return this.cardDepths.get(card.index) ?? 0;
  }

  public dragCardDepth(card: Card): number {
    return this.cardDepth(card) + this.cardDepthOrder + 1;
  }

  private nextCardDepthOrder(): number {
    return this.cardDepthOrder++;
  }
}
